var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('FilterFields', {
    attrs: {
      "fields": [{
        type: 'text',
        label: 'Placa',
        field: 'placa'
      }, {
        type: 'text',
        label: 'Descrição',
        field: 'descricao'
      }]
    }
  }), _c('TableApp', {
    ref: "veiculoList",
    attrs: {
      "titulo": "Veículos",
      "acaoBtn": "/#/veiculos/novo-veiculo",
      "textoBtn": "Novo veículo",
      "api-url": "/veiculos/lista",
      "fields": _vm.fields,
      "classFilterColumn": "descricao",
      "perPage": 10
    },
    scopedSlots: _vm._u([{
      key: "customRow",
      fn: function fn(props) {
        return [props.field == 'descricao' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "descricao"
          },
          slot: "descricao"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(props.rowData.descricao) + " ")])])]) : _vm._e(), props.field == 'renavam' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "valor"
          },
          slot: "valor"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(props.rowData.renavam) + " ")])])]) : _vm._e(), props.field == 'placa' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "valor"
          },
          slot: "valor"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(props.rowData.placa) + " ")])])]) : _vm._e(), props.field == 'actions' ? _c('span', {
          attrs: {
            "slot": "actions"
          },
          slot: "actions"
        }, [_c('div', {
          staticClass: "row-actions",
          staticStyle: {
            "text-align": "right !important"
          }
        }, [_c('span', {
          staticStyle: {
            "overflow": "visible"
          }
        }, [_c('div', {
          staticClass: "action-buttons"
        }, [_c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.bottom",
            value: 'Editar veículo',
            expression: "'Editar veículo'",
            modifiers: {
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-info btn-hover-info btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.handleEditVeiculo(props.rowData);
            }
          }
        }, [_c('Pencil', {
          attrs: {
            "size": 16
          }
        })], 1), _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.bottom",
            value: 'Excluir veículo',
            expression: "'Excluir veículo'",
            modifiers: {
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-danger btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.handleDeleteVeiculo(props.rowData);
            }
          }
        }, [_c('TrashCanIcon', {
          attrs: {
            "size": 16
          }
        })], 1)])])])]) : _vm._e()];
      }
    }])
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };